import { jsx as _jsx } from "react/jsx-runtime";
import { Trans, useTranslation } from "react-i18next";
export const IssueTranslation = ({ issue }) => {
    const { t } = useTranslation("issues");
    return (_jsx(Trans, { t: t, 
        // @ts-ignore
        i18nKey: `issue_${issue.approved ? "" : "un"}approved`, context: issue.name, components: {
            description: _jsx(IssueDescription, { issue: issue }),
        }, values: issue }));
};
export const IssueDescription = ({ issue }) => {
    const { t } = useTranslation("issues");
    return (_jsx(Trans, { t: t, i18nKey: "description", context: issue.approved ? "approved" : issue.signed ? "signed" : "" }));
};
//# sourceMappingURL=IssueTranslation.js.map